import * as React from 'react';
// import { log } from '@haier/kitchen-god';
import lifecycle from 'page-lifecycle';
// @ts-ignore
export default (componentName, componentType = 'function') => {
    function report() {
        // 组件上报
        lifecycle.addEventListener('statechange', (event) => {
            if (event.oldState == 'passive' && event.newState === 'hidden') {
                // log('components-view-pc', {
                //   npm: `${componentName}`,
                // });
            }
        });
    }
    if (componentType === 'class') {
        report();
    }
    else {
        React.useEffect(() => {
            report();
        }, []);
    }
};
